import { Controller } from "@hotwired/stimulus";

// Draws the equalizer bars inside a card's .med-card-waveform. The theme's CSS
// animates .med-wave-bar, so this only has to produce the same 60 spans with
// the same organic heights the source page generates.
const BAR_COUNT = 60;

export default class extends Controller {
  static values = { seed: Number };

  connect() {
    if (this.element.childElementCount) return;
    // Each card gets its own seed so no two waveforms look alike.
    const seed = this.seedValue * 13 + 7;
    const fragment = document.createDocumentFragment();
    for (let i = 0; i < BAR_COUNT; i += 1) {
      const bar = document.createElement("span");
      bar.className = "med-wave-bar";
      bar.style.height = `${this.height(i + seed) * 100}%`;
      fragment.appendChild(bar);
    }
    this.element.appendChild(fragment);
  }

  // Three sine waves at different frequencies multiplied together, which reads
  // as speech rather than as a regular pattern.
  height(position) {
    const wave1 = Math.abs(Math.sin(position * 0.38));
    const wave2 = 0.5 + 0.5 * Math.sin(position * 0.11);
    const wave3 = 0.65 + 0.35 * Math.sin(position * 0.73);
    return Math.max(0.12, Math.min(1, 0.15 + 0.78 * wave1 * wave2 * wave3));
  }
}
